import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { Web3Provider } from './Web3Context.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Web3Provider>
      <App />
    </Web3Provider>
  </React.StrictMode>
);
